export enum SchoolsListColumns {
  REFERENCE_ID = 'Reference ID',
  NAME = 'Name',
  SCHOOL_GROUP = 'School Group',
  ACADEMIC_YEAR = 'Academic Year',
  ACTIVE = 'Deactivated On',
  ACTIONS = 'Actions'
}
